import { render, staticRenderFns } from "./PointTable.vue?vue&type=template&id=708fb56a&"
import script from "./PointTable.vue?vue&type=script&lang=ts&"
export * from "./PointTable.vue?vue&type=script&lang=ts&"
import style0 from "./PointTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports